import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { todayNodeName } from "motw_core/Repositories/WorkflowRepository";
import { ERPGIcon } from "motw_core/UI/Icons/ERPGIcon";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { UnderDevelopment } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/UnderDevelopment";
import { Weather } from "source/app/presentation/MainPanel/Weather/Weather";
import { INavigationMenuItem } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/Helpers/INavigationMenuItem";
import { INavigationMenuItemBadge } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenuItem/NavigationMenuItemBadge/Helpers/INavigationMenuItemBadge";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { State } from "source/app/services/UI/State/State";
import UI from "source/app/services/UI/UI";
import { GotoNodeAsync } from "../../../../services/Workflows/GotoNode";
import Calendar from "../../../MainPanel/Calendar/Calendar";
import Dreams from "../../../MainPanel/Dreams/Dreams";
import LifeChangingEvents from "../../../MainPanel/LifeChangingEvents/LifeChangingEvents";
import Log from "../../../MainPanel/Log/Log";
import LogMonumental from "../../../MainPanel/LogMonumental/LogMonumental";
import Workflows, {
    GetWorkflowsState,
} from "../../../MainPanel/Workflows/Workflows";
import { EBadgeColor } from "./NavigationMenuItem/NavigationMenuItemBadge/EBadgeColor/EBadgeColor";

export const GetNavigationMenuItems = () => navigationMenuItems;

const DefaultBadge: INavigationMenuItemBadge = {
    value: undefined,
    backgroundColor: EBadgeColor.green,
};

const navigationMenuItems: INavigationMenuItem[] = [
    {
        toRender: Log,
        icon: ERPGIcon["arrow-flights"],
        color: `#c79cfd`,
        id: EPanelId.Habits,
        badge: DefaultBadge,
        title: `Habits`,
    },
    {
        toRender: Dreams,
        icon: ERPGIcon.mountains,
        color: `#abd9ff`,
        id: EPanelId.Dreams,
        badge: DefaultBadge,
        title: `Dreams`,
        OnPanelShow: () => OnDreamsPanelShow(),
    },
    {
        toRender: Workflows,
        icon: ERPGIcon["quill-ink"],
        color: `yellowgreen`,
        id: EPanelId.Workflows,
        badge: DefaultBadge,
        OnPanelShow: (args: any) => OnWorkflowsPanelShow(args),
        title: `Workflows`,
    },
    {
        toRender: Weather,
        icon: ERPGIcon.sun,
        color: `yellow`,
        id: EPanelId.Weather,
        badge: DefaultBadge,
        title: `Weather`,
    },
    {
        toRender: Calendar,
        icon: ERPGIcon.clockwork,
        color: `#ea8c8c`,
        id: EPanelId.Calendar,
        badge: DefaultBadge,
        title: `Calendar`,
        OnPanelShow: (args: any) => {
            UI.ScrollToDiv(`#scrollTarget_calendarEventNow`, -150);
        },
    },
    {
        toRender: LogMonumental,
        icon: ERPGIcon["gold-bar"],
        color: `#fbed57`,
        id: EPanelId.LogMonumental,
        badge: DefaultBadge,
        title: `Monumental Achievements`,
    },
    {
        toRender: LifeChangingEvents,
        icon: ERPGIcon.crystals,
        color: `#ffefd1`,
        id: EPanelId.LifeChangingEvents,
        badge: DefaultBadge,
        title: `Life Changing Events`,
    },
    // {
    //     toRender: Hero,
    //     icon: ERPGIcon["knight-helmet"],
    //     color: `#d986d3`,
    //     id: EPanelId.Hero,
    //     badge: DefaultBadge,
    //     title: `Hero's map`,
    // },
    {
        toRender: UnderDevelopment,
        icon: ERPGIcon["battered-axe"],
        color: `black`,
        id: EPanelId.UnderDevelopment,
        badge: DefaultBadge,
        title: `Development`,
        unmountWhenInactive: true,
    },
];

function OnWorkflowsPanelShow(args: any) {
    const goToNodeName: string | undefined = args && args.goToNode;
    const workflows = GetWorkflowsState();

    if (workflows && goToNodeName) {
        const currentNodeName = workflows.state.rootNode.name;

        const isGoToNodeAlreadyActive = currentNodeName === goToNodeName;

        if (!isGoToNodeAlreadyActive) {
            GotoNodeAsync(goToNodeName);
        }

        if (goToNodeName === todayNodeName) {
            const offsetForMiddleOfScreen = window.outerHeight / 2;

            UI.ScrollToDiv(
                "#scrollTarget_searchAddNodes",
                -1 * offsetForMiddleOfScreen
            );
        }
    }
}

function OnDreamsPanelShow() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (!dreams) {
        return;
    }

    window.scrollTo(0, 0);
}
